import { render } from "./DhSlideOverForm.vue?vue&type=template&id=dcc5a800"
import script from "./DhSlideOverForm.vue?vue&type=script&lang=ts"
export * from "./DhSlideOverForm.vue?vue&type=script&lang=ts"
script.render = render

export default script